<template>
  <div class="pb-9">
    <div v-if="loading" class="text-center" style="margin-top: 88px">
      <Loading></Loading>
    </div>
    <v-container v-else style="font-size: 14px">
      <div style="text-align: center" class="py-2 mb-3">
        <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
      </div>
      <div class="Kanit text-center">
        <h2>ข้อตกลงการใช้บริการ</h2>
      </div>
      <div class="Kanit px-2 pt-2">
        <div style="text-indent: 1.5em" class="pb-0">
          ทางบริษัท ทีโอเอ เพ้นท์ (ประเทศไทย) จำกัด (มหาชน) ขอเก็บ ใช้
          หรือเปิดเผยข้อมูลดังต่อไปนี้ เพื่อให้บริการต่างๆ ได้แก่
          บริการสั่งซื้อสินค้า บริการทาสีและซ่อมแซม หรือบริการอื่นๆ
          ภายใต้การดูแลของบริษัท
          ซึ่งจากที่กล่าวมาทั้งหมดจะเป็นไปตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
          พ.ศ. 2562 และระเบียบการคุ้มครองข้อมูลของบริษัทเรา
        </div>
        <div style="text-indent: 1.5em" class="pb-0">
          <span>
            <span style="color: red; font-size: 26px">*</span>
            <span style="position: relative; top: 3px">
              <v-checkbox
                v-model="checkbox1"
                style="display: inline-block"
                hide-details
              ></v-checkbox>
            </span>
            <span
              >ข้าพเจ้ายินยอมให้ทางบริษัทเก็บรวบรวม ใช้
              หรือเปิดเผยข้อมูลส่วนบุคคลของท่านในการให้บริการต่างๆ
              ภายใต้การดูแลของบริษัท ทีโอเอ เพ้นท์ (ประเทศไทย) จำกัด (มหาชน)
            </span>
          </span>
        </div>
        <div style="text-indent: 1.5em" class="pb-0">
          <span>
            <span style="color: red; font-size: 26px; visibility: hidden"
              >*</span
            >
            <span style="position: relative; top: 3px">
              <v-checkbox
                v-model="checkbox2"
                style="display: inline-block"
                hide-details
              ></v-checkbox>
            </span>
            <span
              >ข้าพเจ้ายินยอมให้ทางบริษัทเก็บ ใช้
              หรือเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าในการจัดทำการวิจัยตลาดและการจัดกิจกรรมส่งเสริมการขาย
              หรือเพื่อประโยชน์ในการจัดทำฐานข้อมูลและใช้ข้อมูลเพื่อเสนอสิทธิประโยชน์ตามความสนใจของท่าน
              หรือเพื่อประโยชน์ในการวิเคราะห์และนำเสนอบริการหรือผลิตภัณฑ์ของบริษัท
              ข้าพเจ้ายินยอม
            </span>
          </span>
        </div>
        <div class="mt-5">
          สอบถามข้อมูลเพิ่มเติมหรือแก้ไขข้อมูลส่วนบุคคลของท่าน กรุณาติดต่อ ....
        </div>
      </div>
      <div class="text-center pt-7">
        <div class="Kanit mt-3">
          <v-btn
            :disabled="!checkbox1"
            :loading="saveloading"
            @click="saveConsent"
            class="px-8"
            rounded
            :dark="checkbox1"
            color="rgb(12, 77, 157)"
            >ยอมรับ</v-btn
          >
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";
export default {
  data() {
    return {
      loading: true,
      saveloading: false,
      checkbox1: false,
      checkbox2: false,
    };
  },
  components: {
    Loading,
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  mounted() {
    this.getConsent();
  },
  methods: {
    async close() {
      if (this.query.apptype == "line") {
        await this.$liff.closeWindow();
      } else if (this.query.apptype == "facebook") {
        this.$store.dispatch("messengerClose");
      }
    },
    getConsent() {
      var vm = this;
      axios
        .get("https://communitybotbyzwizai.herokuapp.com/toaconsent", {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
          params: {
            pageid: vm.query.pageid,
            userid: vm.$store.state.userid,
            apptype: vm.query.apptype,
          },
        })
        .then(async (response) => {
          if (response.data && response.data.responsecode == 400) {
            await vm.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          }
          if (response.data.data.length) {
            vm.query.view = "Login";
          } else {
            vm.loading = false;
          }
        });
    },
    saveConsent() {
      var vm = this;
      if (!vm.saveloading) {
        vm.saveloading = true;

        var data = {
          userid: vm.$store.state.userid,
          apptype: vm.query.apptype,
          pageid: vm.query.pageid,
          main_consent: vm.checkbox1, // ติ้กที่ require
          option_consent: vm.checkbox2,
        };
        if (vm.query.user_type == "customer") {
          vm.$store.state.consentData = data;
          if (
            vm.$store.state.viewAfterAgreement &&
            vm.$store.state.viewAfterAgreement == "CustomerAddress"
          ) {
            vm.query.view = "CustomerAddress";
          } else if (vm.$store.state.viewAfterAgreement == "CustomerForm") {
            vm.query.view = "CustomerForm";
          }
        } else {
          axios
            .post(
              "https://communitybotbyzwizai.herokuapp.com/toaconsent",
              data,
              {
                headers: {
                  AUTHORIZATION: "Bearer xxx xxx",
                },
              }
            )
            .then(async (response) => {
              if (response.data && response.data.responsecode == 400) {
                await vm.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              }
              vm.saveloading = false;
              if (response.data.responsecode == 200) {
                if (
                  vm.$store.state.viewAfterAgreement &&
                  vm.$store.state.viewAfterAgreement == "CustomerAddress"
                ) {
                  vm.query.view = "CustomerAddress";
                } else {
                  vm.query.view = "Login";
                }
              }
            });
        }
      }
    },
  },
};
</script>
